import React from "react";
import { useSelector } from "react-redux";
import KolulaBox from "./kolula12/KolulaBox";
import CP12Box from "./cp12/CP12Box";
import { RootState } from "../../../redux/store";
import {
  selectDepotByLocationAndDepotId,
  selectLocationById,
} from "../../../redux/slice/booking/bookingSlice";
import CP67Box from "./cp67/CP67Box";
import CP82Box from "./cp82/CP82Box";
import { BookingSummary } from "../../../types/bookingCreation";
import CP20Box from "./cp20/CP20Box";
import CP6Box from "./cp6/CP6Box";
import PlainDoorsBox from "./PlainDoorsBox";

interface ContainerBoxProps {
  order: BookingSummary;
  activeDoors: number[];
}

const ContainerBox = (props: ContainerBoxProps) => {

  const depotId = props?.order?.items?.[0]?.rental?.doors?.[0]?.depotId || null;

  const displayDepot = useSelector((state: RootState) =>
    depotId
      ? selectDepotByLocationAndDepotId(
          state,
          props?.order?.locationId,
          depotId
        )
      : null
  );

  // Pull the canonical location name from the locations slice (same source the
  // ticket card uses) — the name on the booking payload may not be populated.
  const locationFromSlice = useSelector((state: RootState) =>
    selectLocationById(state, props?.order?.locationId)
  );

  // A depot we cannot resolve is not a reason to render nothing. The customer
  // still has a compartment number, and that is the part they need. Rendering
  // `null` here is how the "Fach öffnen" screen came to be a blank page.
  if (!displayDepot) {
    return (
      <PlainDoorsBox activeDoors={props?.activeDoors ?? []} />
    );
  }

  // Prefer the more descriptive booking location name when the depot name is
  // just a sub-phrase of it (e.g. depot "Studierendenwerk" vs location
  // "Seezeit Studierendenwerk Bodensee"). Falls back to depot.name when the
  // location name is missing.
  const locationName =
    locationFromSlice?.name || props?.order?.location?.name;
  const depotName = displayDepot?.name;
  const headerTitle =
    locationName && depotName && locationName.includes(depotName)
      ? locationName
      : depotName || locationName || "";

  let containerBox;
  switch (displayDepot?.containerType) {
    // case 'db4':
    //     containerBox = <DBBox orderId={props.order.id} activeDoors={props.activeDoors} title={displayDepot.name} />;
    //     break;
    case "cp12":
      containerBox = (
        <CP12Box
          orderId={props?.order?.id}
          activeDoors={props?.activeDoors}
          title={headerTitle}
        />
      );
      break;
    case "cp6":
      containerBox = (
        <CP6Box
          orderId={props?.order?.id}
          activeDoors={props?.activeDoors}
          title={headerTitle}
        />
      );
      break;
    case "cp67":
      containerBox = (
        <CP67Box
          orderId={props?.order?.id}
          activeDoors={props?.activeDoors}
          title={headerTitle}
        />
      );
      break;
    case "cp82":
      containerBox = (
        <CP82Box
          orderId={props?.order?.id}
          activeDoors={props?.activeDoors}
          title={headerTitle}
        />
      );
      break;
    case "cp20": // We need to implement a cp20 layout
      containerBox = (
        <CP20Box
          orderId={props?.order?.id}
          activeDoors={props?.activeDoors}
          title={headerTitle}
        />
      );
      break;
    case "kolula12":
      containerBox = (
        <KolulaBox
          orderId={props?.order?.id}
          activeDoors={props?.activeDoors}
          title={headerTitle}
        />
      );
      break;
    default:
      /*
       * No drawing for this cabinet type — and that is the COMMON case now, not
       * an exotic one: the station wizard sends no container type, so the
       * backend writes its default `'locker'`, which matches none of the six
       * cases above. Falling through to `null` blanked the screen for every
       * wizard-created station.
       *
       * The number is shown instead of an approximate drawing on purpose: a
       * cabinet drawn to another model's layout would point at the wrong door.
       */
      containerBox = (
        <PlainDoorsBox activeDoors={props?.activeDoors ?? []} />
      );
      break;
  }

  return <>{containerBox}</>;
};

export default ContainerBox;
